import { CommonModule } from '@angular/common'
import { Component, inject, input, output } from '@angular/core'

import { Store } from '@ngrx/store'

import { AiAgent } from '@flowx/designer/modules/new-ai/common/ai.dictionary'
import { AiIconsModule } from '@flowx/designer/modules/new-ai/common/icons/ai-icons.module'
import { SwimlaneService } from '@flowx/designer/shared/services/swimlane.service'

const withAiPrefix = [AiAgent.ANALYST, AiAgent.DESIGNER, AiAgent.DEVELOPER]

const labelMap = (
  bpmnHasSwimlanesOrNodes
): Omit<Record<AiAgent, string>, AiAgent.DOCUMENT_INTELLIGENCE> => ({
  [AiAgent.ASSISTANT]: 'Assistant', // 'Get help about FlowX.AI',
  [AiAgent.ANALYST]: 'Analyst', // bpmnHasSwimlanesOrNodes ? 'Edit Process' : 'Generate Process',
  [AiAgent.DESIGNER]: 'Designer', // 'Generate UI',
  [AiAgent.DEVELOPER]: 'Developer',
  [AiAgent.AUDITOR]: 'Auditor',
  [AiAgent.WRITER]: 'Writer',
  [AiAgent.ARCHITECT]: 'Architect',
  [AiAgent.INTEGRATOR]: 'Integrator',
  [AiAgent.SUPERVISOR]: 'Supervisor',
  [AiAgent.INSPECTOR]: 'Inspector',
  [AiAgent.COORDINATOR]: 'Coordinator',
})

@Component({
  selector: 'flx-ai-breadcrumb',
  imports: [CommonModule, AiIconsModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class AiBreadcrumbComponent {
  #store = inject(Store)
  #swimlaneService = inject(SwimlaneService)

  breadcrumbs = input<AiAgent[]>([])
  disabled = input(false)

  segmentLabel = labelMap(this.#swimlaneService.hasSwimlanesOrNodes())

  back = output()

  hasPrefix(crumbState: AiAgent): boolean {
    return withAiPrefix.includes(crumbState)
  }

  goBack(): void {
    this.back.emit()
  }
}
